export default function trackGoogleAnalyticsPageView(action) {
  if (typeof window === 'undefined' || !window.hasOwnProperty('ga')) {
    return;
  }
  const ga = window['ga'];
  ga(() => {
    ga.getAll().forEach(tracker => {
      tracker.send('pageview', { location: window.location.href });
    });
  });
}
